var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addEditForm" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, "label-width": "170px", rules: _vm.rules },
        },
        [
          _c(
            "el-row",
            { staticClass: "marRight20" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "课程名称", prop: "courseName" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.courseName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "courseName", $$v)
                      },
                      expression: "form.courseName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "主持老师", prop: "courseEmceeName" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.courseEmceeName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "courseEmceeName", $$v)
                      },
                      expression: "form.courseEmceeName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "专业大类", prop: "fkCourseMajor" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择专业大类" },
                      model: {
                        value: _vm.form.fkCourseMajor,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "fkCourseMajor", $$v)
                        },
                        expression: "form.fkCourseMajor",
                      },
                    },
                    _vm._l(_vm.prolist, function (i) {
                      return _c("el-option", {
                        key: i.id,
                        attrs: { label: i.majorName, value: i.majorName },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.$store.state.user.userInfo.roleType == 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "学校", prop: "schoolId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "学校" },
                          model: {
                            value: _vm.form.schoolId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "schoolId", $$v)
                            },
                            expression: "form.schoolId",
                          },
                        },
                        _vm._l(_vm.schoolListData, function (i) {
                          return _c("el-option", {
                            key: i.id,
                            attrs: { label: i.name, value: i.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "课程封面：" } },
                [
                  _c("file-upload", {
                    staticClass: "img",
                    attrs: { accept: _vm.accept, propImg: _vm.propImg },
                    on: { successUpLoad: _vm.successUpLoad },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "课程链接", prop: "courseLink" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.courseLink,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "courseLink", $$v)
                      },
                      expression: "form.courseLink",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "排序", prop: "sort" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "10",
                      "show-word-limit": "",
                      placeholder: "请输入排序",
                    },
                    on: {
                      input: function (e) {
                        return (_vm.form.sort = _vm.isnumber(e))
                      },
                    },
                    model: {
                      value: _vm.form.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "sort", $$v)
                      },
                      expression: "form.sort",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "行业分类" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      model: {
                        value: _vm.form.industryDetail,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "industryDetail", $$v)
                        },
                        expression: "form.industryDetail",
                      },
                    },
                    _vm._l(_vm.industryCategoryList, function (i) {
                      return _c("el-option", {
                        key: i.id,
                        attrs: { label: i.name, value: i.remark },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "产业分类" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      model: {
                        value: _vm.form.industry,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "industry", $$v)
                        },
                        expression: "form.industry",
                      },
                    },
                    _vm._l(_vm.industryList, function (i) {
                      return _c("el-option", {
                        key: i.id,
                        attrs: { label: i.name, value: i.name },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "项目级别" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      model: {
                        value: _vm.form.courseLevel,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "courseLevel", $$v)
                        },
                        expression: "form.courseLevel",
                      },
                    },
                    _vm._l(_vm.courseLevelList, function (i) {
                      return _c("el-option", {
                        key: i,
                        attrs: { label: i, value: i },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "submitBtn" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: {
                click: function ($event) {
                  return _vm.submit("form")
                },
              },
            },
            [_vm._v("确定")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.isBack } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }